import axios from "axios";
import AuthUtil from "../utils/AuthUtil";


const API_URL = window.ENV.REACT_APP_CMP_API_URL;

export default class ApiService {
  constructor() {
    this.auth = AuthUtil.getService();
  }

  static get API_URL() {
    return API_URL;
  }

  callApi(url, method, data, header) {
    return this.auth.loadUser().then(user => {
      if (user && user.access_token) {
        return this.invokeRestCall(url, user.access_token, method, data, header).catch(
            error => {
              const status = error?.response?.status;
              const message = error?.response?.message || error?.response?.data?.message;

              // Handle unauthorized or forbidden responses
              if (status === 401 || status === 403) {
                try {
                  this.auth.removeLocalStore();
                } catch (e) {
                  console.error("Error clearing local storage:", e);
                }
                window.location.replace("/");
                return Promise.reject(error);
              }

              // Handle expired JWT case
              if (status > 401 && message === "Expired JWT") {
                return this.auth.silentRenew().then(renewedUser =>
                    this.invokeRestCall(url, renewedUser.access_token, method, data, header)
                );
              }

              // Re-throw all other errors
              throw error;
            });
      } else if (user) {
        return this.auth.silentRenew().then(renewedUser => {
          return this.invokeRestCall(
            url,
            renewedUser.access_token,
            method,
            data,
            header
          );
        });
      } else {
        try { this.auth.removeLocalStore(); } catch (e) {
          console.error("Error clearing local storage");
        }
        window.location.replace("/");
        return Promise.reject(new Error("user is not logged in"));
      }
    });
  }

  invokeRestCall(url, token, method, data, header) {
    let headers;
    let authHeader = {Authorization: "Bearer " + token};
    if (!header) {
       headers = {
         ...authHeader,
        "Content-Type": "application/json",
        Accept: "application/json"
      };
    } else {
      headers = {...header, ...authHeader};
    }

    switch (method) {
      case "get":
        return data === undefined
          ? axios.get(url, { headers })
          : axios.get(url, { params: data, headers });
      case "post":
        return axios.post(url, data, { headers });
      case "put":
        return axios.put(url, data, { headers });
      case "delete":
        if (data)
          return axios.delete(url, { headers, data });
        else
          return axios.delete(url, { headers });
      case "file":
            return axios.get(url, {responseType: 'blob', headers});  
      default:
        return;
    }
  }
}
